import { memo } from 'react';

function UnassignedPickupsMarker({ backgroundColor, borderColor, size  }) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg">
      <path d="M22.78 18V6L12.39 0L2 6V18L12.39 24L22.78 18Z" fill={backgroundColor} />
      <path
        d="M12.39 1.15L21.78 6.57V17.42L12.39 22.84L3 17.42V6.58L12.39 1.15ZM12.39 0L2 6V18L12.39 24L22.78 18V6L12.39 0Z"
        fill={borderColor}
      />
      <path d="M10.3899 6.5L11.3899 13.5H13.3899L14.3899 6.5H10.3899Z" fill={borderColor} />
      <path
        d="M14.3899 17C14.3899 15.8954 13.4945 15 12.3899 15C11.2853 15 10.3899 15.8954 10.3899 17C10.3899 18.1046 11.2853 19 12.3899 19C13.4945 19 14.3899 18.1046 14.3899 17Z"
        fill={borderColor}
      />
    </svg>
  );
}

export default memo(UnassignedPickupsMarker);
